export const PATHS = {
	INDEX: '/',
	SERVICES: '/services'
};
